export const markTypes = ['textStyle', 'bold', 'italic', 'underline', 'strike', 'link'];
